export default "__VITE_ASSET__DSkCN$QA__$_?component__"